<script setup lang="ts">
/* Stores */
import { useDeliveryStore } from '@/store/delivery/delivery'

/* Types */
import { Tag } from '@/api/modules/delivery/types'
type Props = {
  filteredTags: Tag[]
  showPoints: boolean
}

defineProps<Props>()

const deliveryStore = useDeliveryStore()

const cafeEnabled = computed(() => deliveryStore.cafePoints.length > 0)

const title = computed(() =>
  cafeEnabled.value ? 'Кафе и точки самовывоза' : 'Точки самовывоза',
)

const activeTags = computed(() => deliveryStore.activeTags)

const setActiveTags = (value: string[]) => {
  deliveryStore.setActiveTags(value)
}
</script>

<template>
  <section class="delivery__filters">
    <h2 class="delivery__filters-headline">
      <template v-if="showPoints">
        {{ title }}
        <span itemprop="name">FARFOR</span>
      </template>

      <template v-else>В этой области нет ресторанов</template>
    </h2>

    <v-chip-group
      class="delivery__filters-list"
      :model-value="activeTags"
      multiple
      @update:model-value="setActiveTags"
    >
      <v-chip
        v-for="filter in filteredTags"
        :key="filter.slug"
        :value="filter.slug"
        selected-class="active"
        class="filter-item"
      >
        {{ filter.name }}
      </v-chip>
    </v-chip-group>
  </section>
</template>

<style lang="scss" scoped>
:deep {
  .v-chip {
    margin: 0;
    background-color: $button-background;
    transition: 0.2s all ease;

    .v-chip__overlay,
    .v-chip__underlay {
      display: none !important;
    }
  }
  .v-slide-group__content {
    padding: 0;
  }
}
.delivery__filters {
  display: grid;
  align-items: center;
  min-height: 48px;
  padding: 30px;

  @include media('<desktop-mini') {
    padding: 0;
    margin-bottom: 30px;
  }

  &-headline {
    width: max-content;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
    color: #2c2c2c;
  }

  &-list {
    .filter-item {
      padding: 7px 12px;
      margin-right: 10px;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      background-color: $button-background !important;
      border-radius: 40px;
    }
  }

  .active {
    color: $white !important;
    background-color: $primary !important;
  }
}
</style>
